import { isArray } from 'util';
import { MaintenanceTaskConfiguration } from '../maintenance-task-configuration';
import { MaintenanceTaskConfigurationFileBuilder } from './maintenance-task-configuration-file.builder';
import { RoleBuilder } from './role.builder';

export class MaintenanceTaskConfigurationBuilder {
  static fromJson(json) {
    return (json)
      ? new MaintenanceTaskConfiguration(
        json.hash,
        json.model,
        json.name,
        json.frequencyInDays,
        json.duration,
        json.hours,
        json.startDate,
        MaintenanceTaskConfigurationFileBuilder.fromList(json.configurationFiles),
        RoleBuilder.fromList(json.roles)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(MaintenanceTaskConfigurationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/maintenance-task-configuration.builder.ts